<i18n src="../../locales/lang.json"></i18n>
<template>
  <div class="container-fluid">
    <div class="row">

      <div class="col-12" v-if="pages.length > 0">
        <div class="container-fluid p-0">
          <div class="row">
            <div class="col-3">
              <button @click="changePage(pages[visibleIndex - 1],visibleIndex - 1)" v-if="visibleIndex > 0" type="button" class="btn bg-light">
                Back
              </button>
            </div>
            <div class="col-5 text-center">

            </div>
            <div class="col-4 text-right">
              <span style="float: left; margin-left: 22px; margin-top: 7px; color: #9f9c9c;">{{getCurrentPage()}}/{{getTotalPages()}}</span>
              <button @click="changePage(pages[visibleIndex + 1],visibleIndex + 1)" v-if="visibleIndex < lastIndex" type="button" class="btn bg-light">
                Next
              </button>
              <button @click="done" v-if="visibleIndex == lastIndex" type="button" class="btn bg-success" style="color:white;">
                Done
              </button>
            </div>
          </div>

        </div>


      </div>
    </div>
  </div>
 
</template>

<script>

  export default {
    name: "procedure-pager",
    components: {
      
    },
    props: {
      pages: {
        required: false,
        type: Array,
        default: []
      },
    },
    data() {
      return {
        visibleIndex: 0,
        hasPageEnding: false,
      };
    },
    methods: {
      getTotalPages() {
        return this.getVisiblePages().length;
      },
      getCurrentPage() {
        return this.visibleIndex + 1;
      },
      getVisiblePages() {
        var visiblePages = [];
        for (var i = 0; i < this.pages.length; i++) {
          if (this.pages[i].Hidden == false)
            visiblePages.push(this.pages[i])
        }
        return visiblePages;
      },
      done() {
        if (this.hasPageEnding == true) {
          this.$emit("done", true);
          this.changePage(this.pages[this.pages.length - 1], this.pages.length - 1)
        }
        else {
          this.$emit("done", true);
        }
      },
      
      changePage(page, index) {
        this.visibleIndex = index;

        var visiblePages = this.getVisiblePages();

        // Reset the visibility for all pages
        for (var i = 0; i < this.pages.length; i++) {
            this.pages[i].Visible = false;
        }
        for (var i = 0; i < visiblePages.length; i++) {
          if (index == i) {
            visiblePages[i].Visible = true;
          }    
        }
        Vue.set(this, "pages", this.pages);
        this.$emit('changed', this.pages, index);
      },
      getId() {
        return this._uid;
      },

      handleRefresh(val) {
        this.visibleIndex = 0;
        this.$forceUpdate();
        this.init()
      },
      init() {
        for (var i = 0; i < this.pages.length; i++) {
          if (i == 0)
            this.pages[i].Visible = true;
          else
            this.pages[i].Visible = false;
        }
        if (this.pages[this.pages.length - 1].ElementType == 14) // Page ending
        {
          //this.lastIndex = this.pages.length - 2;
          this.hasPageEnding = true;
        }
        //else
        //  this.lastIndex = this.pages.length - 1;
        this.$emit('changed', this.pages, 0);
        this.$forceUpdate();
      }
    },
    computed: {
      lastIndex() {
        var lastindex = 0;
        for (var i = 0; i < this.pages.length; i++) {
          if (this.pages[i].Hidden == false)
            lastindex++;
        }
        return lastindex - 1;
      },
    },
    watch: {
      
    },
    mounted() {
      this.init();
      this.$root.$on('procedure_loaded', this.handleRefresh);
    },
    created() {

    },
  };

</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/procedure/procedure-pager.vue